import React from "react";

const PostOffer = () => {
  return <h1>PostOffer its work</h1>;
};

export default PostOffer;